<svg viewBox="0 0 11 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1.5V0H11V1.5H0Z" fill="currentColor"/>
</svg>
